import * as React from "react";
const SvgProductboard = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 -44 256 256", width: "1em", height: "1em", ...props },
    React.createElement("path", { fill: "#FF2638", d: "m85.327 83.997 85.327 83.996H0z" }),
    React.createElement("path", { fill: "#FFC600", d: "m0 0 85.327 83.997L170.654 0z" }),
    React.createElement("path", { fill: "#0079F2", d: "m85.34 83.997 85.328 83.996 85.327-83.996L170.668 0z" })));
export default SvgProductboard;
//# sourceMappingURL=Productboard.js.map